"use client";

import { useEffect } from "react";

export function EmbedAutoResize({ slug }: { slug: string }) {
  useEffect(() => {
    if (window.parent === window) return;
    let pending = 0;
    let last = 0;
    const send = () => {
      if (pending) return;
      pending = window.setTimeout(() => {
        pending = 0;
        const height = document.documentElement.scrollHeight;
        if (height === last) return;
        last = height;
        window.parent.postMessage(
          { type: "openofferings:height", slug, height },
          "*"
        );
      }, 16);
    };
    send();
    const ro = new ResizeObserver(send);
    ro.observe(document.body);
    return () => {
      ro.disconnect();
      if (pending) clearTimeout(pending);
    };
  }, [slug]);
  return null;
}
